import { css } from '@emotion/react'
import { Theme } from '@mui/material'

export const bannerBlock = ({ theme, expanded }: { theme: Theme; expanded: boolean }) => css`
  padding: ${theme.spacing(12)} 0;
  padding-bottom: ${expanded ? theme.spacing(16) : theme.spacing(12)};
  display: flex;
  color: ${theme.palette.uintel.main};
  text-align: left;
  position: relative;
  justify-content: center;

  h1 {
    line-height: 1.2;
    font-size: 30px;
    font-weight: 700;
    text-shadow:
      0 0 16px rgba(0, 0, 0, 0.1),
      -1px 0 0 #fff8;
  }

  > * {
    z-index: 1;
  }
`

export const bannerContent = css`
  display: flex;
  flex-direction: column;
  width: 1184px;
  max-width: 100%;
  gap: 32px;
`
export const innerBannerColumn = css`
  display: flex;
  flex-direction: column;
  flex: 1 1 0;
  min-width: 0;
  justify-content: center;

  p {
    font-size: 22px;
    font-weight: 400;
    margin-top: 8px;
  }

  img {
    width: 100%;
    height: auto;
    object-fit: contain;
    min-height: 400px;
  }
`
